import { Row, Col, Typography, Image, Space } from 'antd';
import PropTypes from 'prop-types';
import { LRStyle } from './LRStyleSet';

const { Title, Text, Paragraph } = Typography;

function formatDate(value) {
	const date = new Date(value);
	const day = date.getUTCDate().toString().padStart(2, '0');
	const month = date.toLocaleString('default', { month: 'short' });
	const year = date.getFullYear();
	return `${day}-${month}-${year}`;
}

export function LRViewHeader({ details, title }) {
	return (
		<Row>
			<Col span={16}>
				<Row align="middle" gutter={[20, 0]}>
					<Col>
						<Image height={64} src="/ripplrLogo.png" preview={false} />
					</Col>
					<Col span={10} style={{ justifyContent: 'space-around' }}>
						<Row>
							<Col>
								<Title level={4}>Intelligent Retail Private Limited</Title>
							</Col>
						</Row>
						<Row>
							<Col>
								<Paragraph>
									L-73, Attic Space - Drona 4th Floor, 15th Cross, 3rd Main Rd,
									Sector 6, HSR Layout, Bengaluru, Karnataka-560102
								</Paragraph>
							</Col>
						</Row>
					</Col>
					<Col span={8} style={{ justifyContent: 'space-around' }}>
						<Row justify="center">
							<Col span={24}>
								<Row justify="center" gutter={0}>
									<Col>
										<Title level={4}>Consignment Note</Title>
										{/* {title && (
											<div style={{ textAlign: 'center' }}>
												{`[${title}]`}
											</div>
										)} */}
									</Col>
								</Row>
								<Row justify="center">
									<Space direction="horizontal" size="large">
										{/* <div>
											<Checkbox />
											<Image
												height={40}
												src="/ripplrNT.png"
												preview={false}
											/>
										</div>
										<div>
											<Checkbox checked />
											<Image
												height={40}
												src="/ripplrGO.png"
												preview={false}
											/>
										</div> */}
									</Space>
								</Row>
							</Col>
						</Row>
					</Col>
				</Row>
			</Col>
			<Col span={8}>
				<Row gutter={[20, 10]} justify="space-between">
					<Col>
						<Row>
							<Col>
								<Text>Origin:</Text>
							</Col>
						</Row>
						<Row>
							<Col>
								<Text strong style={LRStyle.locationStyle}>
									{details.source_location}
								</Text>
							</Col>
						</Row>
					</Col>
					<Col>
						<Row>
							<Col>
								<Text>Destination:</Text>
							</Col>
						</Row>
						<Row>
							<Col>
								<Text strong style={LRStyle.locationStyle}>
									{details.destination_location}
								</Text>
							</Col>
						</Row>
					</Col>
					<Col>
						<Row>
							<Col>
								<Text>Date of Issue:</Text>
							</Col>
						</Row>
						<Row>
							<Col>
								<Text strong style={LRStyle.locationStyle}>
									{formatDate(details.created_at)}
								</Text>
							</Col>
						</Row>
					</Col>
					<Col>
						<Row>
							<Col>
								<Text>Copy To:</Text>
							</Col>
						</Row>
						<Row>
							<Col>
								<Text strong style={LRStyle.locationStyle}>
									{title}
								</Text>
							</Col>
						</Row>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}

LRViewHeader.propTypes = {
	details: PropTypes.object,
	title: PropTypes.string,
};
